var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav-mobile-menu__list list-unstyled"},_vm._l((_vm.items),function(item,index){return _c('NavigationMenuMobileListItem',{key:'item' + index,attrs:{"item":item},on:{"openSubMenu":function($event){return _vm.openSubMenu(item)},"navClick":function($event){return _vm.navClick(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }